import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import useBlProviders from '../providers/useBlProvider'
import RegulationsDt from '@/services/dataTransferModules/regulationsDt'

export default function useRegulations() {
	const regulationsDt = new RegulationsDt()
	const { t: $t } = useI18n()

	const { defaultBlFlags } = useBlProviders()

	const flags = reactive({
		...defaultBlFlags,
	})

	const defaults = {
		creatingField: {
			name: '',
			description: '',
			tags: [],
			period: '',
			updated_at: '',
			application_area: {},
			regulation_type: '',
			material_cost_date: '',
		},
		fieldsToPatch: [
			'name',
			'description',
			'tags',
			'period',
			'updated_at',
			'application_area',
			'regulation_type',
			'material_cost_date',
		],
	}

	const {
		selectedCompanyId,
		entities: regulations,
		getEntities: getRegulations,

		basedEntities: basedRegulations,
		getBasedEntities: getBasedRegulations,

		extendedEntities: extendedRegulations,
		getExtendedEntities: getExtendedRegulations,

		entity: regulation,
		getEntity: getRegulation,

		entityPreview: previewRegulation,
		getEntityPreview: getPreviewRegulations,

		entityPopup: popupRegulation,
		getEntityPopup: getPopupRegulations,

		createEntity: createRegulation,
		updateEntity: putRegulation,
		patchEntity: patchRegulation,
		deleteEntity: deleteRegulation,
	} = useBlProviders(
		regulationsDt,
		{
			getAllMethodName: 'getFilteredRegulations',
			getAllBasedMethodName: 'getFilteredBasedRegulations',

			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Error loading regulations'),

			showErrorNotificationForCreatingEntity: true,
			errorNotificationTextForCreatingEntity: $t('Error creating regulations'),

			showErrorNotificationForLoadingOneEntity: true,
			errorNotificationTextForLoadingOneEntity: $t('Error loading regulations'),

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Error editing regulations'),

			showErrorNotificationForDeletingEntity: true,
			errorNotificationTextForDeletingEntity: $t('Error deleting regulations'),

			showErrorNotificationForLoadingBasedEntities: true,
			errorNotificationTextForLoadingBasedEntities: $t('Error loading regulations'),

			showErrorNotificationForLoadingExtendedEntities: true,
			errorNotificationTextForLoadingExtendedEntities: $t('Error loading regulations'),
		}
	)

	const regulationHasMetricType = (regulationId, metricType) => {
		return new Promise((resolve, reject) => {
			regulationsDt
				.regulationHasMetricType(selectedCompanyId.value, regulationId, {
					metric_type: metricType,
				})
				.then((res) => {
					resolve(res)
				})
				.catch((err) => {
					reject(err)
				})
		})
	}

	const regulationAddStageAndPlanWorks = (regulationId, body) => {
		return new Promise((resolve, reject) => {
			regulationsDt
				.regulationAddStageAndPlanWorks(selectedCompanyId.value, regulationId, body)
				.then((res) => {
					resolve(res)
				})
				.catch((err) => {
					reject(err)
				})
		})
	}

	return {
		flags,
		regulations,
		basedRegulations,
		extendedRegulations,
		previewRegulation,
		popupRegulation,
		regulation,
		defaults,

		getBasedRegulations,
		getExtendedRegulations,
		getRegulations,
		getPreviewRegulations,
		getPopupRegulations,
		getRegulation,
		createRegulation,
		putRegulation,
		patchRegulation,
		deleteRegulation,

		regulationHasMetricType,
		regulationAddStageAndPlanWorks,
	}
}
